// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1bef584e","239":"dac06248","455":"034fd728"}[chunkId] + ".chunk.js";
};